var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERRORS } from './constants/errors';
import { generateCallbackName, base64ToString } from './util/util';
import { sendToNative } from './native';
var globalScope = window;
var registryCallbackWithPromise = function (resolve, reject, name, timeout) {
    if (timeout === void 0) { timeout = 0; }
    var timeId = -1;
    if (timeout > 0) {
        // @ts-ignore
        timeId = setTimeout(function () {
            reject({
                err: ERRORS.TIMEOUT,
                extData: {}
            });
        }, timeout);
    }
    var callbackFunction = function (b64) {
        if (timeId) {
            clearTimeout(timeId);
        }
        var response = JSON.parse(base64ToString(b64));
        if (Array.isArray(response)) {
            var err = response[0], extData = response.slice(1);
            if (err) {
                reject({
                    err: err,
                    extData: extData,
                });
            }
            else {
                resolve({
                    extData: extData,
                    err: ERRORS.NULL,
                });
            }
        }
        else {
            resolve({
                err: ERRORS.NULL,
                extData: response,
            });
        }
    };
    globalScope[name] = callbackFunction;
};
var registryCallback = function (name, callback, timeout) {
    if (timeout === void 0) { timeout = 0; }
    var timeId = -1;
    if (timeout > 0) {
        // @ts-ignore
        timeId = setTimeout(function () {
            globalScope[name] = '';
            callback(ERRORS.TIMEOUT);
        }, timeout);
    }
    globalScope[name] = function (b64) {
        clearTimeout(timeId);
        callback.apply(null, b64 ? JSON.parse(base64ToString(b64)) : [null]);
    };
};
var removeCallback = function (name) {
    globalScope[name] = '';
};
export var sendMessage = function (name, params, timeout, prefix) {
    if (params === void 0) { params = {}; }
    if (timeout === void 0) { timeout = 0; }
    if (prefix === void 0) { prefix = ''; }
    // extraTriggers用于添加拓展的回调方法，数组类型
    var trigger = params.trigger, shareTrigger = params.shareTrigger, callback = params.callback, extraTriggers = params.extraTriggers;
    var triggerName = generateCallbackName(name);
    var message = __assign(__assign(__assign({}, params), (trigger && {
        trigger: triggerName
    })), (shareTrigger && {
        shareCallback: triggerName
    }));
    registryAndAddExtraTriggersToMessage(message, extraTriggers);
    // 如果trigger  callback都没有传，就生成一个默认函数做参数
    var callbackName = generateCallbackName(name + "_callback");
    var shouldUseUserDefinedCallback = (!(trigger || shareTrigger)) && callback;
    var encodeParams = Buffer.from(JSON.stringify({
        arguments: [message],
        callback: shouldUseUserDefinedCallback ? triggerName : callbackName
    })).toString('base64');
    return new Promise(function (resolve, reject) {
        // 注册默认callback
        if (!shouldUseUserDefinedCallback) {
            var doNothing = function () {
                //
            };
            registryCallback(callbackName, doNothing, timeout);
        }
        if (trigger || shareTrigger || callback) {
            registryCallbackWithPromise(resolve, reject, triggerName, timeout);
        }
        else {
            resolve({
                err: ERRORS.NULL,
                extData: []
            });
        }
        var res = sendToNative(name, encodeParams, prefix);
        // 没有webview或者webview没有要执行的方法，则移除该方法回调
        if (!res && shouldUseUserDefinedCallback) {
            removeCallback(triggerName);
            removeExtraTriggers(extraTriggers);
        }
        else if (!res && !shouldUseUserDefinedCallback) {
            removeCallback(callbackName);
            removeExtraTriggers(extraTriggers);
        }
    });
};
export var sendMessageWithCallback = function (name, params, timeout, prefix) {
    if (params === void 0) { params = {}; }
    if (timeout === void 0) { timeout = 0; }
    if (prefix === void 0) { prefix = ''; }
    // extraTriggers用于添加拓展的回调方法，数组类型
    var trigger = params.trigger, shareTrigger = params.shareTrigger, callback = params.callback, extraTriggers = params.extraTriggers;
    var triggerName = generateCallbackName(name);
    // 如果trigger  callback都没有传，就生成一个默认函数做参数
    var callbackName = generateCallbackName(name + "_callback");
    var shouldUseUserDefinedCallback = (!(trigger || shareTrigger)) && callback;
    var message = __assign(__assign(__assign({}, params), (trigger && {
        trigger: triggerName
    })), (shareTrigger && {
        shareCallback: triggerName
    }));
    registryAndAddExtraTriggersToMessage(message, extraTriggers);
    if (trigger || shareTrigger || callback) {
        registryCallback(triggerName, trigger || shareTrigger || callback, timeout);
    }
    // 注册默认callback
    if (!shouldUseUserDefinedCallback) {
        var doNothing = function () {
            //
        };
        registryCallback(callbackName, doNothing, timeout);
    }
    var encodeParams = Buffer.from(JSON.stringify({
        arguments: [message],
        callback: shouldUseUserDefinedCallback ? triggerName : callbackName
    })).toString('base64');
    var res = sendToNative(name, encodeParams, prefix);
    // 没有webview或者webview没有要执行的方法，则移除该方法回调
    if (!res && shouldUseUserDefinedCallback) {
        removeCallback(triggerName);
        removeExtraTriggers(extraTriggers);
    }
    else if (!res && !shouldUseUserDefinedCallback) {
        removeCallback(callbackName);
        removeExtraTriggers(extraTriggers);
    }
};
var removeExtraTriggers = function (extraTriggers) {
    extraTriggers && extraTriggers.forEach(function (extraTrigger) {
        removeCallback(extraTrigger.generateTriggerName);
    });
};
var registryAndAddExtraTriggersToMessage = function (message, extraTriggers) {
    if (!extraTriggers) {
        return;
    }
    extraTriggers = generateExtraTriggerNames(extraTriggers);
    extraTriggers.forEach(function (extraTrigger) {
        message[extraTrigger.triggerName] = extraTrigger.generateTriggerName;
        registryCallback(extraTrigger.generateTriggerName, extraTrigger.trigger, extraTrigger.timeout);
    });
};
var generateExtraTriggerNames = function (extraTriggers) {
    return extraTriggers && extraTriggers.map(function (extraTrigger) {
        var triggerName = generateCallbackName(extraTrigger.triggerName + "_extra");
        extraTrigger.generateTriggerName = triggerName;
        return extraTrigger;
    }) || [];
};
